import _ from 'lodash';

import {
  setEditorFieldValue,
  setEditorNumberValue,
  setFunctionValue
} from '../Section/setEditorFieldValue';

const navigateToSummaryNoQuery = (setTaskValues, stages, hideConfirmModal) => {
  setTaskValues({
    currentStage: stages[stages.length - 1]
  });
  hideConfirmModal();
};

const navigateToSummary = (
  props,
  showConfirmModal,
  hideConfirmModal,
  setInvalidDocumentsError,
  forced = false
) => {
  hideConfirmModal();
  const {
    task: { claimId },
    setTaskValues,
    setErrorMessage,
    submitSections,
    taskType,
    taskValues: {
      stages,
      selectedDocuments,
      selectedAirRefundDocuments,
      selectedCourtDocuments,
      sectionsData,
      fullPaxFieldsData,
      options: { passengerTicketIds, ...options }
    }
  } = props;
  const taskName =
    taskType === 'LFN' ? 'legalFormalNotice' : 'courtApplication';
  const returnIdsArray = prevArray => prevArray.map(doc => doc.id);
  const language = options.languageOption || 'fr';

  const onSuccess = ({ errors }) => {
    if (errors) return null;
    setTaskValues({
      currentStage: stages[stages.length - 1]
    });
    hideConfirmModal();
  };

  const onError = error => {
    const [message, documents] = _
      .get(error, 'networkError.result.message', '')
      .split(':');
    if (message === 'Created document type exist') {
      showConfirmModal();
    } else if (message === 'Invalid documents') {
      setInvalidDocumentsError(documents, message);
    } else {
      setErrorMessage('there was an error sending query');
    }
  };

  const sections = Object.keys(sectionsData).reduce((prevGroup, currGroup) => {
    return [
      ...prevGroup,
      ...Object.keys(sectionsData[currGroup]).reduce(
        (prevSection, currSection) => {
          const { sectionFields, template } = sectionsData[currGroup][
            currSection
          ];
          const formattedPaxData = sectionFields.reduce((prev, curr) => {
            let { type, value } = _.find(fullPaxFieldsData, ['id', curr]);
            return {
              ...prev,
              [curr]:
                type === 'function'
                  ? setFunctionValue(value, fullPaxFieldsData)
                  : setEditorFieldValue(type, value, language)
            };
          }, {});
          return [...prevSection, _.template(template)(formattedPaxData)];
        },
        0
      )
    ];
  }, 0);

  const fields = fullPaxFieldsData.reduce((prev, curr) => {
    const { id, value, type } = curr;
    const setValue = () => {
      if (type.includes('float')) {
        return setEditorNumberValue(language, curr.value);
      }
      if (type === 'integer') {
        return curr.value.toString();
      }
      if (type === 'function') {
        return setEditorNumberValue(
          language,
          setFunctionValue(value, fullPaxFieldsData)
        );
      }
      return value;
    };
    return {
      ...prev,
      [id]: value ? setValue() : value
    };
  }, {});

  let dataToSend = {
    claimId,
    forced,
    passengerTicketIds,
    sections,
    [`${taskName}DocumentFields`]: fields,
    [`${taskName}DocumentOptions`]: options
  };

  if (taskType === 'LFN') {
    dataToSend = {
      ...dataToSend,
      documentIds: returnIdsArray(selectedDocuments)
    };
  } else {
    dataToSend = {
      ...dataToSend,
      passengerDocumentIds: returnIdsArray(selectedDocuments),
      airrefundDocumentIds: returnIdsArray(selectedAirRefundDocuments),
      courtDocumentIds: returnIdsArray(selectedCourtDocuments)
    };
  }
  submitSections({ ...dataToSend }, { onSuccess, onError });
};

export { navigateToSummaryNoQuery, navigateToSummary };



// WEBPACK FOOTER //
// ./src/component/TaskCreator/NavigationWrapper/navigateToSummary.js